var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.passwordModalIsOpen
        ? _c("modal-password", {
            attrs: { callback: _vm.deleteUser },
            on: {
              cancel: function ($event) {
                _vm.passwordModalIsOpen = false
              },
            },
          })
        : _vm._e(),
      _vm.changeDefaultIsOpen
        ? _c("modal-change-default", {
            attrs: {
              isOpen: _vm.changeDefaultIsOpen,
              merchant: _vm.merchantSelected,
            },
            on: { closeModal: _vm.hideChangeDefault },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "eu-pt_3" },
        [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "router-link",
                {
                  staticClass: "emd-btn _type_link",
                  attrs: {
                    to: { name: _vm.originRouteName, query: _vm.userQuery },
                    tag: "button",
                  },
                },
                [
                  _c("i", { staticClass: "uil uil-arrow-left" }),
                  _vm._v(" " + _vm._s(_vm.$t("back")) + " "),
                ]
              ),
            ],
            1
          ),
          _vm.selectedUser
            ? [
                _vm.showAlertUserDeleted
                  ? _c(
                      "emd-alert",
                      {
                        attrs: { variant: "success" },
                        on: {
                          cancel: function ($event) {
                            _vm.showAlertUserDeleted = false
                          },
                        },
                      },
                      [
                        _c("template", { slot: "content" }, [
                          _c("p", [_vm._v(_vm._s(_vm.$t("userDeleted")))]),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "data-display",
                  {
                    attrs: {
                      sectionName:
                        _vm.selectedUser.first_name +
                        " " +
                        _vm.selectedUser.last_name,
                      status: _vm.userStatus,
                      tableData: _vm.profileData,
                    },
                  },
                  [
                    _vm.showBtnRemove
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "emd-btn _type_outline _color_danger eu-mt_3",
                            on: {
                              click: function ($event) {
                                _vm.passwordModalIsOpen = true
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "uil uil-trash" }),
                            _vm._v(" " + _vm._s(_vm.$t("remove")) + " "),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "data-display",
                  {
                    attrs: {
                      sectionName: _vm.$t("mfaSectionTitle"),
                      status: _vm.mfaStatus,
                      tableData: _vm.mfaData,
                    },
                  },
                  [_c("tfa-section")],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "el-section" },
        [
          _c("emd-tabs", {
            attrs: { tabs: _vm.tabs },
            on: { changed: _vm.changed },
            scopedSlots: _vm._u([
              {
                key: "permissions_mundi",
                fn: function () {
                  return [
                    _c("permissions-wrapper", {
                      attrs: {
                        loading: _vm.loadingList,
                        permissions: _vm.permissions,
                      },
                      on: {
                        openModalChangeDefault: _vm.openModalChangeDefault,
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "permissions_pagarme",
                fn: function () {
                  return [
                    _c("permissions-wrapper", {
                      attrs: {
                        loading: _vm.loadingList,
                        permissions: _vm.permissions_pagarme,
                      },
                      on: {
                        openModalChangeDefault: _vm.openModalChangeDefault,
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }